
export enum SORT_DIR{
    DESC = "DESC",
    ASC = "ASC"
}

export interface SortItem{
    key: string,
    sortDir: SORT_DIR
}

export class Sort_Utils{

    private listSort : SortItem[] = [];


    public getSortDir(key: string): string{
        if(this.listSort.filter(e => e.key == key).length == 0){
            this.listSort.push({key: key, sortDir: SORT_DIR.ASC});
        }
        let item = this.listSort.filter(e => e.key == key)[0];
        item.sortDir = item.sortDir == SORT_DIR.DESC ? SORT_DIR.ASC : SORT_DIR.DESC;
        return item.sortDir;
    }

    getImgSort(key: string): string{
        let returnObj = 'sort-solid_deactive.svg';
        if(this.listSort.filter(o => o.key == key).length > 0){
            let obj = this.listSort.filter(o => o.key == key)[0];
            if(obj.sortDir == SORT_DIR.ASC){
                returnObj = 'sort-solid_active_ASC.png';
            } else {
                returnObj = 'sort-solid_active_DESC.png';
            }
        }
        return returnObj;
    }

}